import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  InAppBrowser,
  InAppBrowserOptions,
} from "@ionic-native/in-app-browser/ngx";
import { AlertController, LoadingController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { STORAGE } from "../../../constant/storages";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { TEXT } from "../../../text_control";
import { BTN } from "../../../text_control/text_button";
import { TEXT_TABLE } from "../../../text_control/text_table";
import { _getStorage } from "../../../utils/local-storage";

@Component({
  selector: "app-replace-preview",
  templateUrl: "./replace-preview.component.html",
  styleUrls: ["./replace-preview.component.scss"],
})
export class ReplacePreviewComponent implements OnInit {
  sub: any;
  browser: InAppBrowser;
  dataAddress: any;
  dataitem: any;
  showbtn = false;
  Active: Number;
  options: InAppBrowserOptions = {
    location: "yes", //Or 'no'
    hideurlbar: "yes",
    navigationbuttoncolor: "white",
    toolbarcolor: "red",
    toolbarposition: "top",
    closebuttoncaption: "CLOSE",
    closebuttoncolor: "white",
    hidden: "no", //Or  'yes'
    clearcache: "yes",
    clearsessioncache: "yes",
    zoom: "yes", //Android only ,shows browser zoom controls
    hardwareback: "yes",
    mediaPlaybackRequiresUserAction: "no",
    shouldPauseOnSuspend: "no", //Android only
    disallowoverscroll: "no", //iOS only
    toolbar: "yes", //iOS only
    enableViewportScale: "no", //iOS only
    allowInlineMediaPlayback: "no", //iOS only
    presentationstyle: "pagesheet", //iOS only
    fullscreen: "yes", //Windows only
  };

  text: any = {};
  textBTN: any = {};
  textTB: any = {};

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  constructor(
    private route: ActivatedRoute,
    private iab: InAppBrowser,
    public appService: AppService,
    public alertController: AlertController,
    public apiservice: ApiserviceService,
    public loadingController: LoadingController,
    public storeg: Storage
  ) {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.text = TEXT;
    this.textBTN = BTN;
    this.textTB = TEXT_TABLE
  }

  ngOnInit() { }
  ionViewDidEnter() {
    this.route.queryParams.subscribe((params) => {
      if (params.noName === "no_replace") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 2;
      }
    });
    this.sub = _getStorage(STORAGE.DATA_PREVIEW_REPLACE)

  }

  openbrowser(item) {

    let target = "_self";
    if (item.res_inet.status === "ER") {
      alert("error");
    } else {
      const browser = this.iab.create(
        item.res_inet.pdfURL,
        target,
        this.options
      );
    }
  }

  async getPDF(item) {
    let target = "_self";
    const req_load_pdf = {
      taxno: item.new_taxinvoice_no,
      storebu: this.userBu,
      storeid: this.userLoc,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userRole: this.userRole,
      userSource: this.userSource,
      user_id: this.userID,
      mtrans_id: item.mtrans_id,
    };
    console.log("======== req load pdf =======: ", req_load_pdf);
    try {
      this.apiservice
        ._post(this.apiservice.apiUrl + this.apiservice.getNewPDF, req_load_pdf)
        .then((res) => {
          console.log("======== res load pdf =======: ", res);
          if (res.statusCode === 200) {
            const browser = this.iab.create(res.data, target, this.options);
            this.showbtn = true;
            item.isDownload = true;
          } else {
            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      // this.ErrorMsg(errMsg.error);
    }
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  checkbranch(data: any) {
    if (data.buyer_type === "0") {
      return "-";
    } else if (data.buyer_type === "1") {
      if (data.buyer_main_branch_no === "00000") {
        return "สำนักงานใหญ่";
      } else {
        return data.buyer_branch_no;
      }
    } else if (data.buyer_type === "2") {
      return "-";
    } else {
      return "-";
    }
  }
  checkaddress(item) {
    if (item.type_addr === "1") {
      return item.addr_info;
    } else if (item.type_addr === "2") {
      return item.addr_infoEN;
    }
  }
}
